export const Periodicity = {
    SCHEDULE_PERIODICITY_BY_CLICK: 0,
    SCHEDULE_PERIODICITY_BY_WEEK: 1,
    SCHEDULE_PERIODICITY_BY_MONTH: 2,
};
